import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const SettingsWrapper = styled.div`
    max-width: 50%;
    padding: ${SPACING.SMALL_4};
`;

export const ProductCardWrapper = styled.div`
    padding: ${SPACING.SMALL_4};
    cursor: not-allowed;
    * {
        pointer-events: none;
    }
`;
